module.exports = __webpack_public_path__ + "img/cab_1000_2.fbe90587.jpg";